import { Component, OnInit, Input } from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import {DependencesService} from '../../../../services/dependences.service';
import * as moment from 'moment';

@Component({
  selector: 'ngx-update-legal-requirement',
  templateUrl: './update-legal-requirement.component.html',
  styleUrls: ['./update-legal-requirement.component.scss'],
})
export class UpdateLegalRequirementComponent implements OnInit {

  @Input() stationId: string;
  @Input() requirement: any;

  loading = false;
  date: any;
  showDateEdit = false
  parentDeliverable: any = null

  constructor(
    protected ref: NbDialogRef<UpdateLegalRequirementComponent>,
    private dependenciesService: DependencesService,
  ) { }

  close() { this.ref.close(false); }

  ngOnInit() {
    const deliverables = this.requirement.requirement ? this.requirement.requirement.deliverables : this.requirement.deliverables
    if (deliverables.length) {
      this.parentDeliverable = deliverables.find(deliverable => deliverable.parent)
      if (this.parentDeliverable) {
        this.showDateEdit = true
        this.date = new Date(moment(this.parentDeliverable.date, 'YYYY-MM-DD').format('YYYY/MM/DD'))
      }
    }
  }

  async store() {
    const data: any = {
      periodicity: this.requirement.periodicity,
      dependence_id: this.requirement.pivot ? this.requirement.pivot.legal_requirement_dependence_id: this.requirement.legal_requirement_dependence_id
    }
    if (this.showDateEdit) {
      data.deliverable_parent_id = this.parentDeliverable.id,
      data.date = moment(this.date).format('YYYY-MM-DD')
    } else {
      data.requirement_id = this.requirement.id
    }
    this.loading = true;
    const [error] = await this.dependenciesService.updateDateDeliverableParent(this.stationId, data);
    this.loading = false;
    if (error) return console.error(error);
    this.ref.close(true)
  }

}
